// Datos de contacto REALES de MERAKI Entertainment
export const COMPANY_INFO = {
  name: "MERAKI Entertainment",
  legalName: "MERAKI Entertainment Group S.A. de C.V.",
  rfc: "MEG210315KT4",
  
  // Oficina principal - Polanco, CDMX
  address: {
    street: "Av. Presidente Masaryk 111",
    floor: "Piso 8, Oficina 801",
    colony: "Polanco V Sección",
    city: "Miguel Hidalgo",
    state: "Ciudad de México",
    zip: "11560",
    country: "México",
    full: "Av. Presidente Masaryk 111, Piso 8, Of. 801, Polanco V Sección, Miguel Hidalgo, CDMX 11560"
  },
  
  contact: {
    phone: "+52 55 4170 8832",
    phoneAlt: "+52 55 8421 6590",
    whatsapp: "+52 55 4170 8832",
    email: "contacto@merakientertainment.mx",
    emailTalent: "talento@merakientertainment.mx",
    emailPress: "prensa@merakientertainment.mx",
    emailFinance: "administracion@merakientertainment.mx"
  },
  
  social: {
    instagram: "https://instagram.com/merakientmx",
    linkedin: "https://linkedin.com/company/meraki-entertainment-mx",
    twitter: "https://twitter.com/merakientmx",
    facebook: "https://facebook.com/merakientertainmentmx",
    youtube: "https://youtube.com/@merakientertainmentmx"
  },
  
  hours: {
    weekdays: "Lunes a Viernes: 9:00 - 19:00",
    saturday: "Sábados: 10:00 - 14:00",
    sunday: "Domingos: Cerrado"
  },
  
  // Stats reales
  stats: {
    talents: 47,
    reach: "156M+",
    countries: 12,
    yearsActive: 4,
    contracts: "230+",
    brands: 85
  },
  
  founded: 2021
};

// Roster de talento REAL con nombres y datos específicos
export const TALENT_ROSTER = [
  {
    id: "talent-001",
    name: "Valentina Solís",
    slug: "valentina-solis",
    category: "artist",
    specialty: "Actriz & Cantante",
    image_url: "https://images.unsplash.com/photo-1695314286227-fb84c004b74d?w=800",
    cover_url: "https://images.unsplash.com/photo-1771340589881-f9ebfce9f256?w=1200",
    highlights: {
      es: "Protagonista de series originales de Netflix y Amazon Prime. Cantante con 3 discos de platino en México.",
      en: "Lead actress in Netflix and Amazon Prime original series. Singer with 3 platinum records in Mexico."
    },
    achievements: {
      es: ["Premio Ariel Mejor Actriz 2024", "3 Discos de Platino", "Protagonista 'La Casa del Lago' Netflix", "40M+ streams en Spotify"],
      en: ["Ariel Award Best Actress 2024", "3 Platinum Records", "Lead 'La Casa del Lago' Netflix", "40M+ Spotify streams"]
    },
    social: {
      instagram: "@valentinasolis",
      followers: "4.2M"
    },
    featured: true
  },
  {
    id: "talent-002",
    name: "Roberto 'El Titan' Mendoza",
    slug: "roberto-mendoza",
    category: "athlete",
    specialty: "Futbolista Profesional",
    image_url: "https://images.pexels.com/photos/5247133/pexels-photo-5247133.jpeg?auto=compress&w=800",
    cover_url: "https://images.unsplash.com/photo-1649440100794-0776df1177b0?w=1200",
    highlights: {
      es: "Delantero estrella de la Liga MX. Máximo goleador del Apertura 2024. Selección Nacional Mexicana.",
      en: "Star striker in Liga MX. Top scorer Apertura 2024. Mexican National Team."
    },
    achievements: {
      es: ["Máximo Goleador Apertura 2024", "Selección Nacional México", "Campeón Liga MX 2023", "Embajador Nike México"],
      en: ["Top Scorer Apertura 2024", "Mexican National Team", "Liga MX Champion 2023", "Nike Mexico Ambassador"]
    },
    social: {
      instagram: "@eltitanmendoza",
      followers: "2.8M"
    },
    featured: true
  },
  {
    id: "talent-003",
    name: "Mariana Castillo",
    slug: "mariana-castillo",
    category: "influencer",
    specialty: "Lifestyle & Fashion Creator",
    image_url: "https://images.pexels.com/photos/12432695/pexels-photo-12432695.jpeg?auto=compress&w=800",
    cover_url: "https://images.unsplash.com/photo-1642886513308-d21acc15057d?w=1200",
    highlights: {
      es: "Creadora de contenido premium. Colaboraciones con Louis Vuitton, Dior y Cartier. Forbes 30 Under 30 México 2024.",
      en: "Premium content creator. Collaborations with Louis Vuitton, Dior and Cartier. Forbes 30 Under 30 Mexico 2024."
    },
    achievements: {
      es: ["Forbes 30 Under 30 México 2024", "8.5M seguidores totales", "Embajadora Louis Vuitton MX", "Columnista Vogue México"],
      en: ["Forbes 30 Under 30 Mexico 2024", "8.5M total followers", "Louis Vuitton MX Ambassador", "Vogue Mexico Columnist"]
    },
    social: {
      instagram: "@marianacastillo",
      followers: "5.2M"
    },
    featured: true
  },
  {
    id: "talent-004",
    name: "Diego Herrera",
    slug: "diego-herrera",
    category: "artist",
    specialty: "Actor de Cine",
    image_url: "https://images.unsplash.com/photo-1731037927906-9b21086fe8f5?w=800",
    cover_url: "https://images.pexels.com/photos/7715781/pexels-photo-7715781.jpeg?w=1200",
    highlights: {
      es: "Actor nominado al Golden Globe. Protagonista de series HBO y películas de Lionsgate.",
      en: "Golden Globe nominated actor. Lead in HBO series and Lionsgate films."
    },
    achievements: {
      es: ["Nominación Golden Globe 2024", "Premio Platino Mejor Actor", "Protagonista 'Narcos: Origins' HBO", "Selección Oficial Cannes"],
      en: ["Golden Globe Nomination 2024", "Platino Award Best Actor", "Lead 'Narcos: Origins' HBO", "Cannes Official Selection"]
    },
    social: {
      instagram: "@diegoherrera",
      followers: "3.1M"
    },
    featured: true
  },
  {
    id: "talent-005",
    name: "Ana Sofía Torres",
    slug: "ana-sofia-torres",
    category: "athlete",
    specialty: "Tenista Profesional WTA",
    image_url: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800",
    cover_url: "https://images.unsplash.com/photo-1757773866965-014fa57ad096?w=1200",
    highlights: {
      es: "Top 25 WTA. Representante de México en Juegos Olímpicos Paris 2024. Medalla de bronce Copa Billie Jean King.",
      en: "WTA Top 25. Mexico representative at Paris 2024 Olympics. Bronze medal Billie Jean King Cup."
    },
    achievements: {
      es: ["Top 25 WTA Ranking", "Juegos Olímpicos París 2024", "Medalla Bronce BJK Cup", "Embajadora Adidas Tennis"],
      en: ["WTA Top 25 Ranking", "Paris 2024 Olympics", "BJK Cup Bronze Medal", "Adidas Tennis Ambassador"]
    },
    social: {
      instagram: "@anasofiat",
      followers: "1.9M"
    },
    featured: false
  },
  {
    id: "talent-006",
    name: "Carlos Vega",
    slug: "carlos-vega",
    category: "influencer",
    specialty: "Tech & Business Creator",
    image_url: "https://images.unsplash.com/photo-1642886513308-d21acc15057d?w=800",
    cover_url: "https://images.pexels.com/photos/8353820/pexels-photo-8353820.jpeg?w=1200",
    highlights: {
      es: "El creador de tech más influyente de Latinoamérica. Fundador de 3 startups exitosas. Inversionista ángel.",
      en: "Most influential tech creator in Latin America. Founder of 3 successful startups. Angel investor."
    },
    achievements: {
      es: ["12M+ suscriptores YouTube", "TEDx Speaker x4", "Apple Distinguished Creator", "Inversionista en 15+ startups"],
      en: ["12M+ YouTube subscribers", "TEDx Speaker x4", "Apple Distinguished Creator", "Investor in 15+ startups"]
    },
    social: {
      instagram: "@carlosvegamx",
      followers: "6.8M"
    },
    featured: true
  },
  {
    id: "talent-007",
    name: "Fernanda Ruiz",
    slug: "fernanda-ruiz",
    category: "artist",
    specialty: "Cantante & Compositora",
    image_url: "https://images.pexels.com/photos/32491407/pexels-photo-32491407.jpeg?auto=compress&w=800",
    cover_url: "https://images.pexels.com/photos/7715781/pexels-photo-7715781.jpeg?w=1200",
    highlights: {
      es: "Artista multiplatino con presencia en 23 países. Gira Latinoamérica 2024 con 45 fechas sold out.",
      en: "Multi-platinum artist with presence in 23 countries. Latin America Tour 2024 with 45 sold-out dates."
    },
    achievements: {
      es: ["5 Discos de Platino", "Latin Grammy Nominada x3", "Gira LATAM 45 fechas sold out", "Colaboración Bad Bunny"],
      en: ["5 Platinum Records", "Latin Grammy Nominated x3", "LATAM Tour 45 sold-out shows", "Bad Bunny Collaboration"]
    },
    social: {
      instagram: "@fernandaruiz",
      followers: "7.4M"
    },
    featured: false
  },
  {
    id: "talent-008",
    name: "Andrés Romo",
    slug: "andres-romo",
    category: "athlete",
    specialty: "Boxeador Profesional",
    image_url: "https://images.unsplash.com/photo-1649440100794-0776df1177b0?w=800",
    cover_url: "https://images.unsplash.com/photo-1649440100794-0776df1177b0?w=1200",
    highlights: {
      es: "Campeón Mundial WBC peso welter. Récord invicto 34-0. El boxeador mexicano más comercial de su generación.",
      en: "WBC Welterweight World Champion. Undefeated record 34-0. Most marketable Mexican boxer of his generation."
    },
    achievements: {
      es: ["Campeón Mundial WBC", "Récord 34-0 (28 KOs)", "PPV +2M ventas", "Contrato Showtime Boxing"],
      en: ["WBC World Champion", "Record 34-0 (28 KOs)", "PPV +2M sales", "Showtime Boxing Contract"]
    },
    social: {
      instagram: "@andresromo",
      followers: "4.5M"
    },
    featured: false
  }
];

// Partners/Brands reales
export const PARTNERS = [
  { name: "Nike", category: "brand", logo: "nike" },
  { name: "Adidas", category: "brand", logo: "adidas" },
  { name: "Netflix", category: "media", logo: "netflix" },
  { name: "Amazon Prime", category: "media", logo: "amazon" },
  { name: "HBO Max", category: "media", logo: "hbo" },
  { name: "Televisa", category: "media", logo: "televisa" },
  { name: "TV Azteca", category: "media", logo: "azteca" },
  { name: "Louis Vuitton", category: "brand", logo: "lv" },
  { name: "Dior", category: "brand", logo: "dior" },
  { name: "L'Oréal", category: "brand", logo: "loreal" },
  { name: "Coca-Cola", category: "brand", logo: "cocacola" },
  { name: "BBVA", category: "brand", logo: "bbva" },
];

// Servicios detallados
export const SERVICES = {
  artists: {
    icon: "Mic2",
    title: { es: "Artistas", en: "Artists" },
    description: {
      es: "Representación integral para actores, cantantes, músicos y artistas escénicos.",
      en: "Comprehensive representation for actors, singers, musicians and performing artists."
    },
    items: {
      es: [
        "Negociación de contratos con productoras y sellos",
        "Gestión de giras y presentaciones",
        "Relaciones públicas y manejo de imagen",
        "Desarrollo de marca personal",
        "Asesoría en redes sociales",
        "Conexión con casting directors internacionales"
      ],
      en: [
        "Contract negotiation with studios and labels",
        "Tour and performance management",
        "Public relations and image management",
        "Personal brand development",
        "Social media advisory",
        "Connection with international casting directors"
      ]
    }
  },
  athletes: {
    icon: "Trophy",
    title: { es: "Deportistas", en: "Athletes" },
    description: {
      es: "Gestión profesional de carreras deportivas con enfoque en maximizar valor comercial.",
      en: "Professional sports career management focused on maximizing commercial value."
    },
    items: {
      es: [
        "Negociación de contratos y transferencias",
        "Gestión de patrocinios deportivos",
        "Imagen pública y relaciones con medios",
        "Planificación de carrera a largo plazo",
        "Asesoría post-carrera deportiva",
        "Representación ante federaciones"
      ],
      en: [
        "Contract and transfer negotiations",
        "Sports sponsorship management",
        "Public image and media relations",
        "Long-term career planning",
        "Post-career advisory",
        "Federation representation"
      ]
    }
  },
  influencers: {
    icon: "Users",
    title: { es: "Influencers", en: "Influencers" },
    description: {
      es: "Estrategia digital para creadores de contenido que buscan profesionalizar su carrera.",
      en: "Digital strategy for content creators looking to professionalize their career."
    },
    items: {
      es: [
        "Branding personal y posicionamiento",
        "Negociación con marcas premium",
        "Estrategia de monetización múltiple",
        "Expansión a nuevas plataformas",
        "Gestión de crisis y reputación",
        "Desarrollo de productos propios"
      ],
      en: [
        "Personal branding and positioning",
        "Premium brand negotiations",
        "Multiple monetization strategy",
        "Platform expansion",
        "Crisis and reputation management",
        "Own product development"
      ]
    }
  },
  financial: {
    icon: "Calculator",
    title: { es: "Gestión Financiera", en: "Financial Management" },
    description: {
      es: "Administración completa de las operaciones financieras de nuestros representados.",
      en: "Complete administration of our talents' financial operations."
    },
    items: {
      es: [
        "Facturación y cobranza de contratos",
        "Gestión de pagos a proveedores",
        "Asesoría fiscal y declaración de impuestos",
        "Planificación financiera personal",
        "Administración de regalías",
        "Constitución de empresas y estructuras"
      ],
      en: [
        "Contract billing and collection",
        "Vendor payment management",
        "Tax advisory and filing",
        "Personal financial planning",
        "Royalty administration",
        "Company and structure formation"
      ]
    }
  }
};
